import { Store } from '@tanstack/react-store';

// Define the available themes and modes for type safety
export type Mode = 'light' | 'dark' | 'system';
export type Theme = (typeof THEMES)[number];

// Define the shape of our store's state
export type ThemeState = {
    theme: Theme;
    mode: Mode;
};

export const THEMES = ['default', 'electrical', 'solar'] as const;
export const THEME_STORAGE_KEY = import.meta.env.VITE_UI_THEME_STORAGE_KEY || 'vite-ui-theme';

// Function to get the initial state from localStorage or set defaults
function getInitialState(): ThemeState {
    ///
    try {
        const storedState = window.localStorage.getItem(THEME_STORAGE_KEY);
        if (storedState) {
            return JSON.parse(storedState) as ThemeState;
        }
    }
    // If parsing fails, fall back to default
    catch (error) {
        console.error('Error reading theme from localStorage', error);
    }

    // Default state if nothing is stored
    return {
        theme: 'default',
        mode: 'light', // 'system' is a great default for dark mode
    };
}

// Create the store instance with the initial state
export const themeStore = new Store<ThemeState>(getInitialState());

// Subscribe to store changes and persist them to localStorage
themeStore.subscribe(() => {
    const state = themeStore.state;
    try {
        window.localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(state));
    }
    catch (error) {
        console.error('Error saving theme to localStorage', error);
    }
});
